<div class="line-holder">
  <h3 class="resolution-index">{{index+1}}</h3>
  <textarea type="text" id="{{ 'name-' + index }}" class="name" (keyup)="onNameInput($event)" (input)="common.autoHeight($event, 4)" 
  maxlength="255" placeholder="{{'POLL-CREATION.QUESTIONS.RESOLUTION-INPUT-PLACEHOLDER' | translate}}"
  ></textarea>
  <img *ngIf="index != 0" id="delete-button" (click)="delete()" src="assets/delete.svg">
  <div *ngIf="index == 0" class="delete-placeholder"></div>
</div>
